<template>
  <div class='eleFence'>
    <div class="title">默认围栏</div>
    <div class="fenceList bg7" @click='goUrl(list.familyFence,"familyFence")'>
       <img src='@/assets/img/equipment/fence7.png' class="img2">
       <template v-if='list.familyFence'>
         <p class="txt">{{list.familyFence.fenceName}}</p>
         <p class="note">{{list.familyFence.fenceAddress}}</p>
       </template>
       <template v-else>
         <p>家庭坐标</p><p class="note" style='color:#ef3a0e'>暂未设置围栏位置</p>
       </template>
    </div>
    <div class="fenceList bg8" @click='goUrl(list.schoolFence,"schoolFence")' v-if='list.schoolFence'>
         <img src='@/assets/img/equipment/fence8.png' class="img2">
         <p class="txt">{{list.schoolFence.fenceName}}</p>
         <p class="note">{{list.schoolFence.fenceAddress}}</p>
    </div>
     <div class="title">自定义围栏</div>
     <div :class="'fenceList bg'+getNum(index)" v-for="(item,index) in list.fenceList" :key='index' @click='goUrl(item,"otherFence")'>
        <i class="img1"></i>
        <div class='del' @click.stop="delectCon(item)"><svg-icon icon-class="del"  /></div>
        <p class="txt">{{item.fenceName}}</p>
        <p class="note">{{item.fenceAddress}}</p>
     </div>
     <div class='fenceList addBtn' @click="goUrl()">
       <img src='@/assets/img/equipment/fenceAdd.png' class="img2"><br><span class='note'>新增围栏位置</span>
     </div>
  </div>
</template>
<script>
import {getStudentFenceList,deleteFence} from "@/api/api.equipment";
  export default {
    data() {
      return {
        list:'',
      }
    },
   created(){
     this.getList();
    },
    methods: {
     
      getNum(i){
        let num=(i/6).toFixed(1).split('.');
        return num[1]
      },
       getList(){
         getStudentFenceList({
              schoolId:this.loginUser.schoolId,
              studentId:this.loginUser.studentId
           }).then((data) => {
            if (data && data.result) {
              this.list=data.result;
            }
           })
       },
       goUrl(item,code){
         let query={fenceTypeCode:code||'otherFence'};
         if(item){
           query={
             id:item.fenceId,
             fenceTypeCode:code
           }
         }
         this.$router.push({
           name:'fenceDetail',
           query:query
         })
       },
       delectCon(item){
         this.$dialog.confirm({ 
            message: '确定删除该围栏吗',
            confirmButtonColor:'#2403df',
            confirmButtonText:'确定'
         }).then(() => {
              deleteFence({
                  fenceId:item.fenceId,
              }).then((data) => {
                if (data && data.result) {
                   this.$toast('删除成功');
                   this.getList();
                }else{
                  this.$toast(data.message);
                }
              })
         }).catch(() => {
          // on cancel
         });
       }
    },
  }
</script>
<style lang="scss" >
.eleFence{
  padding:.15rem .1rem;
  .title{
    font-size: .15rem;
    font-weight: 550;
    padding-top: .1rem;
  }
  .fenceList{
    width:46%;
    margin:.15rem 2%;
    height:1.5rem;
    display: inline-block;
    background:#fff;
    padding:.15rem .2rem;
    border-radius:26px;
    font-size:.15rem;
    line-height: .2rem;
    color:#333;
    vertical-align: top;
    position: relative;
    .txt{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .img1{
      width:.4rem;
      height:.4rem;
      display: block;
      background:url(../../../assets/img/equipment/fence1.png) no-repeat center;
      background-size:100% 100%;
      margin-bottom:.12rem;
    }
    .img2{
      width:.4rem;
      margin-bottom:.08rem;
    }
    .note{
      margin-top:.07rem;
      color:#999;
      font-size: .13rem;
      overflow:hidden;
      text-overflow: ellipsis;
      word-break:break-all;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
    }
    &.bg0{
      background:rgba(11, 204, 158,.1);
      .img1{
         background-image:url(../../../assets/img/equipment/fence3.png);
       }
    }
    &.bg2{
      background:rgba(255, 81, 80,.1);
      .img1{
         background-image:url(../../../assets/img/equipment/fence4.png);
       }
    }
    &.bg3{
      background:rgba(255, 152, 207,.1);
      .img1{
         background-image:url(../../../assets/img/equipment/fence5.png);
       }
    }
    &.bg5{
      background:rgba(36, 3, 223,.1);
      .img1{
         background-image:url(../../../assets/img/equipment/fence6.png);
       }
    }
    &.bg7{
       background:rgba(255, 128, 77,.1);
       .img1{
         background-image:url(../../../assets/img/equipment/fence1.png);
       }
    }
    &.bg8{
      background:rgba(0, 122, 255,.1);
      .img1{
         background-image:url(../../../assets/img/equipment/fence2.png);
       }
    }
    &.addBtn{
      text-align:center;
      background:#fff;
      img{
        margin-top:.2rem;
        margin-bottom: 0rem;
      }
    }
    .del{
      position: absolute;
      right:15px;
      top:.23rem;
      color:#7f7f7f;
      .svg-icon{
        width: .2rem;
        height: .2rem;
        margin-right: 0px;
      }
    }
  }
}

</style>